module.exports = __webpack_public_path__ + "static/media/tower1.b26c02fe.jpg";